var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoustoDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,200C44.8,200,0,155.2,0,100S44.8,0,100,0s100,44.8,100,100S155.2,200,100,200z M100,16.7 C54,16.7,16.7,54,16.7,100S54,183.3,100,183.3s83.3-37.4,83.3-83.3S146,16.7,100,16.7z M66.7,83.3c-9.2,0-16.7-7.4-16.7-16.7 S57.4,50,66.7,50s16.7,7.4,16.7,16.7S75.9,83.3,66.7,83.3z M100,158.3c-22,0-41.1-14.1-47.7-35c-1.4-4.4,1-9,5.5-10.4 c4.3-1.4,9,1,10.4,5.5c4.3,13.9,17.2,23.3,31.8,23.3s27.5-9.4,31.8-23.3c1.4-4.4,6.1-6.9,10.5-5.5c4.3,1.4,6.8,6,5.3,10.4 C141.1,144.3,122,158.3,100,158.3z M133.3,83.3c-9.2,0-16.7-7.4-16.7-16.7S124.1,50,133.3,50S150,57.4,150,66.7 S142.6,83.3,133.3,83.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoustoDiscount);
export default __webpack_public_path__ + "static/media/Gousto_Discount.f4cdb01f074f5b34f9bef8207616fd82.svg";
export { ForwardRef as ReactComponent };